module.exports = __webpack_public_path__ + "static/media/team3.b728c269.png";